import { useEffect, useState } from 'react'
import type { Agent } from '../types'
import { apiUrl } from '../lib/api'

interface AgentsResponse {
  agents: Agent[]
  count: number
  generated_at: string
}

export function useAgents() {
  const [agents, setAgents] = useState<Agent[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await fetch(apiUrl('/api/agents'))
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data: AgentsResponse = await response.json()
        setAgents(data.agents)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch agents')
        setAgents([])
      } finally {
        setLoading(false)
      }
    }

    fetchAgents()
    
    // Poll every 30 seconds
    const interval = setInterval(fetchAgents, 30000)
    return () => clearInterval(interval)
  }, [])

  return { agents, loading, error }
}
